import { useEffect } from "react";

const API_BASE = window.location.hostname === "localhost" ? "http://localhost:5000" : "";

const STARTED_KEY = "bloomberg_manual_support_fetch_started_v1";
const AUTO_KEY = "bloomberg_manual_support_auto_refresh_v1";
const ROWS_KEY = "bloomberg_manual_support_rows_v1";
const FETCHED_KEY = "bloomberg_manual_support_fetched_once_v1";

const TABS = [
  { id: "nifty-ce", chainKey: "nifty", side: "CE" },
  { id: "nifty-pe", chainKey: "nifty", side: "PE" },
  { id: "banknifty-ce", chainKey: "banknifty", side: "CE" },
  { id: "banknifty-pe", chainKey: "banknifty", side: "PE" },
  { id: "sensex-ce", chainKey: "sensex", side: "CE" },
  { id: "sensex-pe", chainKey: "sensex", side: "PE" },
  { id: "bankex-ce", chainKey: "bankex", side: "CE" },
  { id: "bankex-pe", chainKey: "bankex", side: "PE" },
];

function shouldRun() {
  return (
    localStorage.getItem(STARTED_KEY) === "1" &&
    localStorage.getItem(AUTO_KEY) === "1"
  );
}

async function fetchAllManualSupportRows() {
  const res = await fetch(`${API_BASE}/api/bloomberg/snapshot?t=${Date.now()}`, {
    cache: "no-store",
  });

  const data = await res.json().catch(() => ({}));
  const rowsByTab = {};

  TABS.forEach(tab => {
    const chain = data.optionChains?.[tab.chainKey];
    const sourceRows = tab.side === "CE" ? chain?.calls || [] : chain?.puts || [];

    rowsByTab[tab.id] = sourceRows
      .filter(row => Number(row.ltp || 0) >= 5 && Number(row.ltp || 0) <= 600)
      .sort((a, b) => Number(b.ltp || 0) - Number(a.ltp || 0));
  });

  localStorage.setItem(ROWS_KEY, JSON.stringify(rowsByTab));
  localStorage.setItem(FETCHED_KEY, "1");

  window.dispatchEvent(
    new CustomEvent("bloomberg-manual-support-rows", {
      detail: { rowsByTab },
    })
  );
}

export default function GlobalBloombergManualSupportFetcher() {
  useEffect(() => {
    let timer = null;

    const startOrStop = () => {
      if (timer) clearInterval(timer);

      if (!shouldRun()) return;

      fetchAllManualSupportRows().catch(() => {});

      timer = setInterval(() => {
        fetchAllManualSupportRows().catch(() => {});
      }, 1000);
    };

    startOrStop();

    window.addEventListener("bloomberg-manual-support-fetch-control", startOrStop);

    return () => {
      if (timer) clearInterval(timer);
      window.removeEventListener("bloomberg-manual-support-fetch-control", startOrStop);
    };
  }, []);

  return null;
}